import React from "react";
import "../styles/DeleteAccount.css";
import Header from "../components/Header"; // ✅ Certifique-se de que o caminho está correto

export default function DeleteAccountRondaGO() {
  return (
    <>
      <Header /> {/* ✅ Aqui o Header será exibido no topo da página */}

      <div className="delete-account-container">
        <h1>Excluir conta – RondaGO</h1>
        <p>Você pode excluir sua conta diretamente no app RondaGO.</p>

        <h2>Como excluir sua conta:</h2>
        <ol>
          <li>Abra o aplicativo RondaGO.</li>
          <li>Acesse o menu de Perfil ou Configurações.</li>
          <li>Selecione “Excluir Conta” e confirme.</li>
        </ol>

        <h2>O que acontece ao excluir sua conta:</h2>
        <ul>
          <li>Seu e-mail, nome e dados de acesso serão excluídos permanentemente.</li>
          <li>Empreendimentos cadastrados por você continuarão ativos se houver outros administradores.</li>
          <li>Não armazenamos dados pessoais após a exclusão.</li>
          <li>Dados anônimos (como logs) podem ser mantidos por até 30 dias para fins de segurança e estatísticas.</li>
        </ul>

        <p>
          <strong>Precisa de ajuda?</strong> <br />
          <a href="mailto:contato@rondago.com.br">Fale com a gente: contato@rondago.com.br</a>
        </p>
      </div>
    </>
  );
}
